/**
 * @fileoverview Version badge component
 * Displays the current app version in the bottom-right corner
 * Version is automatically extracted from Git tags at build time
 */

interface VersionBadgeProps {
  version?: string;
  className?: string;
}

/**
 * Version badge component that shows the app version
 * Positioned fixed in bottom-right corner by default
 *
 * The version is injected at build time from Git tags via vite.config.ts
 */
export function VersionBadge({
  version = import.meta.env.VITE_APP_VERSION || "dev",
  className = "",
}: VersionBadgeProps) {
  return (
    <div
      className={`bg-muted/50 text-muted-foreground fixed right-2 bottom-2 z-50 rounded-md px-2 py-1 text-xs backdrop-blur-sm ${className}`}
      role="contentinfo"
      aria-label={`App version ${version}`}
    >
      v{version}
    </div>
  );
}
